var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_17014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3457 20.6445C10.0867 20.6445 9.83831 20.5416 9.65517 20.3585C9.47203 20.1754 9.36914 19.927 9.36914 19.668V1.62109C9.36914 1.36209 9.47203 1.1137 9.65517 0.93056C9.83831 0.747419 10.0867 0.644531 10.3457 0.644531C10.6047 0.644531 10.8531 0.747419 11.0362 0.93056C11.2194 1.1137 11.3223 1.36209 11.3223 1.62109V19.668C11.3223 19.927 11.2194 20.1754 11.0362 20.3585C10.8531 20.5416 10.6047 20.6445 10.3457 20.6445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3691 11.6211H1.32227C1.06327 11.6211 0.814873 11.5182 0.631732 11.3351C0.448591 11.1519 0.345703 10.9035 0.345703 10.6445C0.345703 10.3855 0.448591 10.1371 0.631732 9.954C0.814873 9.77086 1.06327 9.66797 1.32227 9.66797H19.3691C19.6281 9.66797 19.8765 9.77086 20.0597 9.954C20.2428 10.1371 20.3457 10.3855 20.3457 10.6445C20.3457 10.9035 20.2428 11.1519 20.0597 11.3351C19.8765 11.5182 19.6281 11.6211 19.3691 11.6211Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_17014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.345703 0.644531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5c424342235902ccad6c8cc8384ec266.svg";
export { ForwardRef as ReactComponent };